import React from "react";

import {
  DEFAULT_SMALL_COUNT_THRESHOLD,
  formatCount,
  suppressedCountLabel,
} from "@utils/formatting/formatCount";

import ToolTip from "../ToolTip/ToolTip";

interface SuppressedCountProps {
  value: number | string | null | undefined;
  suppressed?: boolean | null;
  threshold?: number | null;
  testId?: string;
}

const SuppressedCount = ({
  value,
  suppressed,
  threshold,
  testId = "suppressed-count",
}: SuppressedCountProps) => {
  if (!suppressed) {
    return <>{formatCount(value)}</>;
  }
  return (
    <ToolTip
      text={`Counts under ${threshold ?? DEFAULT_SMALL_COUNT_THRESHOLD} are hidden`}
      style={{ display: "inline-block" }}
    >
      <span data-testid={testId}>{suppressedCountLabel(threshold)}</span>
    </ToolTip>
  );
};

export default SuppressedCount;
